module.exports = __webpack_public_path__ + "img/cases-3.4dd9cd47.png";